<template>
  <div class="order-details-card">
    <div class="title">
      <span>借款额度(元)</span>
      <span class="span">{{ amountFormatter(orderDetails.borrowAmount) }}</span>
    </div>
    <!--借款期限：-->
    <div class="term-wrap">
      <div class="term-item border-right">
        <span class="term-label">年利率</span>
        <span class="span">{{ orderDetails.annualizedRatio }}%</span>
      </div>
      <div class="term-item border-right">
        <span class="term-label">分期期数</span>
        <span class="span">{{ orderDetails.issueOrderNum }}期</span>
      </div>
      <div class="term-item">
        <span class="term-label">每期天数</span>
        <span class="span">{{ orderDetails.issueDay }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { amountFormatter } from "@/utils/utils";

export default {
  name: "orderDetailsCard",
  data() {
    return {
      amountFormatter,
    };
  },
  async mounted() {},
  methods: {},
  computed: {
    orderDetails() {
      return this.$store.getters.orderDetails;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  display: flex;
  align-items: center;
  color: #333333;
  justify-content: space-between;
  flex-direction: column;
  padding-top: 20px;
  .span {
    font-weight: 500;
    font-size: 46px;
    margin-top: 8px;
  }
}
.term-wrap {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 16px;
  padding-top: 20px;
  .term-item {
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #333333;
    font-size: 15px;
    width: 32%;
    .span {
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      padding-top: 4px;
    }
  }
  .border-right {
    border-right: solid 1px rgba(0,0,0,0.1);
  }
}
</style>
